// Presentation only: invitation decisions and curriculum IDs remain API values.
const entries = {
  'title': ['convites para vagas','invitaciones a ofertas','job invitations'],
  'loading': ['carregando convites','cargando invitaciones','loading invitations'],
  'empty': ['nenhum convite recebido','no has recibido invitaciones','no invitations received'],
  'load error': ['não foi possível carregar os convites','no se pudieron cargar las invitaciones','invitations could not be loaded'],
  'retry': ['tentar novamente','volver a intentar','try again'],
  'curriculum': ['currículo','currículum','curriculum'],
  'choose curriculum': ['escolha um currículo','elige un currículum','choose a curriculum'],
  'my curriculum': ['meu currículo','mi currículum','my curriculum'],
  'version': ['versão','versión','version'],
  'accept': ['aceitar','aceptar','accept'],
  'reject': ['recusar','rechazar','decline'],
  'saving': ['enviando resposta','enviando respuesta','sending response'],
  'decision error': ['não foi possível enviar sua resposta. Tente novamente','no se pudo enviar tu respuesta. Vuelve a intentarlo','your response could not be sent. Try again'],
  'accepted': ['convite aceito','invitación aceptada','invitation accepted'],
  'rejected': ['convite recusado','invitación rechazada','invitation declined'],
  'status invited': ['aguardando resposta','pendiente de respuesta','awaiting response'],
  'status accepted': ['aceito','aceptada','accepted'],
  'status rejected': ['recusado','rechazada','declined'],
  'status unknown': ['situação indisponível','estado no disponible','status unavailable'],
  'loading curriculums': ['carregando currículos','cargando currículums','loading curriculums'],
  'curriculum error': ['não foi possível carregar seus currículos','no se pudieron cargar tus currículums','your curriculums could not be loaded'],
  'no curriculum': ['você precisa de um currículo pronto para aceitar um convite','necesitas un currículum listo para aceptar una invitación','you need a ready curriculum to accept an invitation'],
};
export default Object.fromEntries(['pt','es','en'].map((locale,index)=>[
  locale,Object.fromEntries(Object.entries(entries).map(([key,values])=>[`job invitations ${key}`,values[index]])),
]));
